import t from 'format-message'
import {useDocumentTitle as useDocumentTitleHook} from 'usehooks-ts'

/**
 * This hook sets the document title to a formatted string based on the provided title. Uses
 * `useDocumentTitle` from `usehooks-ts` under the hood. The final title will be in the format
 * `"Quizzes - { title }"`, where { title } is replaced by the provided title.
 *
 * @param {string} title - The title to be displayed in the document title.
 */
export function useDocumentTitle(title) {
  return useDocumentTitleHook(t('Quizzes - { title }', {title}))
}
